export default (state =[], action) => {
	switch (action.type) {
		case 'FETCH_SESSION':
			return action.payload;
		default:
			return state;
	}
};